import React from "react";
import { useEffect, useState, useRef, useLayoutEffect } from "react";
// import './FaultFirstPageCustom_bus.css';
import * as $ from "jquery";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

// import useHttp from '../../../../hook/use-http';
import useHttp from "../../../hook/use-http";
// import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
// import NoData from '../../Driveanalysis_Bus/NoData_Bus';
// import WaterMark from '../../../Dashboard/DashboardMain/WaterMark';
import WaterMark from "../DashboardMain_Bus/WaterMark";
// import BucketTable_Fault_Click from './BucketTable_Fault_Click';
// import BucketTable_Fault_Click_Imb from './BucketTable_Fault_Click_Imb';
// import CommanBarTable_Bus from './CommanBarTable_Bus';

export default function COmpBiDirTest(props) {
  let { title, template_id, soarting, gloablfilter, unit, IND } = props;
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [show, setShow] = useState(false);
  const [setsignal_name, setSignalName] = useState("");
  const handleClose = () => setShow(false);
  useEffect(() => {
    let dataO = props.dataMain;
    let root = am5.Root.new(props.id);
    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        // panX: false,
        // panY: false,
        // wheelX: "panX",
        // wheelY: "zoomX",
        layout: root.verticalLayout,
        arrangeTooltips: false,
      })
    );

    // chart.getNumberFormatter().set("numberFormat", "#.#s");
    chart.getNumberFormatter().set("numberFormat", "#.#s'%");

    let yAxis = chart.yAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "age",
        // renderer: yRenderer,
        renderer: am5xy.AxisRendererY.new(root, {
          inversed: true,
          cellStartLocation: 0.1,
          cellEndLocation: 0.9,
          minGridDistance: 1,
        }),
      })
    );

    yAxis.data.setAll(dataO);
    yAxis.get("renderer").grid.template.set("forceHidden", true);

    let xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererX.new(root, {
          strokeOpacity: 0.1,
        }),
      })
    );

    xAxis.get("renderer").grid.template.set("forceHidden", true);
    chart.zoomOutButton.set("forceHidden", true);

    function createSeries(
      field,
      labelCenterX,
      pointerOrientation,
      rangeValue,
      colSanku,
      orgLeval,
      levalLable
    ) {
      let series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          fill: am5.color(colSanku),
          stroke: am5.color(colSanku),
          xAxis: xAxis,
          yAxis: yAxis,
          valueXField: field,
          categoryYField: "age",
          // valueYField: tipSanku,//
          categoryXField: orgLeval, //
          sequencedInterpolation: true,
          clustered: false,
          tooltip: am5.Tooltip.new(root, {
            // getFillFromSprite: false,
            pointerOrientation: pointerOrientation,
            // labelText: "{categoryY}: {valueX}" //org
            // labelText: levalLable + ": {categoryX}[/]\n{categoryY}: {valueX}",
            labelText: levalLable + ": {categoryX}",
            // oversizedBehavior: "fit",
          }),
        })
      );

      series.columns.template.setAll({
        height: am5.p100,
        // strokeOpacity: 0,
        // fillOpacity: 0.8,
        // tooltipText: "{categoryX}:{valueY}"
        strokeOpacity: 0.1,
        strokeWidth: 3,
        fillOpacity: 1,
      });

      series.bullets.push(function () {
        return am5.Bullet.new(root, {
          // locationX: 0.7,
          // locationY: 1,
          sprite: am5.Label.new(root, {
            centerY: am5.p50,
            text: "{valueX}",
            populateText: true,
            centerX: labelCenterX,
          }),
        });
      });

      // code for label hover
      var yRenderer1 = yAxis.get("renderer");

      yRenderer1.labels.template.setAll({
        // tooltipText: "[fontSize: 12px]Signal name: {signal_nm}[/]\n[fontSize: 12px]Description: {signal_desc}[/]\n[fontSize: 12px]Value: {signal_val}",
        tooltipText:
          "[fontSize: 12px]Description: {signal_desc}[/]\n[fontSize: 12px]Value: {signal_val}",
        // width: 150,
        // maxWidth: 150,
        // textAlign: "end",
        // fontFamily: "NotoSans-Regular",
        fontSize: 12,
        fill: am5.color("#000000"),
        oversizedBehavior: "fit",
      });

      yRenderer1.labels.template.setup = function (target) {
        target.set(
          "background",
          am5.Rectangle.new(root, {
            fill: am5.color("#5d9eab"),
            fillOpacity: 0,
          })
        );
      };
      // code for label hover

      series.data.setAll(dataO);
      series.appear();

      let rangeDataItem = xAxis.makeDataItem({
        value: rangeValue,
      });

      xAxis.createAxisRange(rangeDataItem);
      rangeDataItem.get("grid").setAll({
        strokeOpacity: 1,
        stroke: series.get("stroke"),
      });

      function compareObjects(object1, object2, key) {
        const obj1 = object1.duration.value;
        const obj2 = object2.duration.value;
        if (obj1 > obj2) {
          return -1;
        }
        if (obj1 < obj2) {
          return 1;
        }
        return 0;
      }
      function responceBarData(data) {
        SetfilteredData(data);
        data.sort((value1, value2) => {
          return compareObjects(value1, value2, "value");
        });
        SetfilteredData(data);
        // setShow(true);
        window.$("#exampleModal__data" + props.id).modal("show");
      }
      series.columns.template.events.on("click", function (ev) {
        const signal_name = ev.target.dataItem._settings.categoryY;
        const count = ev.target.dataItem._settings.categoryX;
        let signal_name_orignal;
        setSignalName(signal_name);

        setShow(props.unit);

        for (let i = 0; i < props.signal_name.length; i++) {
          if (signal_name === props.signal_name[i].toUpperCase()) {
            signal_name_orignal = props.signal_name[i];
          }
        }
        if (props.type === "Fault" && props.unit !== "sp")
          fetchData(
            {
              url:
                API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusFault_click",
              body: {
                filterdata: gloablfilter,
                signalNav: signal_name_orignal,
                type: props.type,
                defaultNav: props.unit,
              },
            },
            responceBarData
          );
        if (props.type === "Alarm" && props.unit !== "sp")
          fetchData(
            {
              url:
                API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusAlarm_click",
              body: {
                filterdata: gloablfilter,
                signalNav: signal_name_orignal,
                type: props.type,
                defaultNav: props.unit,
              },
            },
            responceBarData
          );
        if (props.type === "Fault" && props.unit === "sp")
          fetchData(
            {
              url:
                API_URL_MAIN +
                "faultfirstpage_bus/vehicleLevalBusCritical_click",
              body: {
                filterdata: gloablfilter,
                signalNav: signal_name_orignal,
                type: props.type,
                defaultNav: props.unit,
              },
            },
            responceBarData
          );
        if (
          props.type === "IMB" &&
          signal_name === "A_PACK" &&
          props.id === "chartdivCurrImb"
        )
          fetchData(
            {
              url:
                API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusPackA_click",
              body: {
                filterdata: gloablfilter,
                signalNav: signal_name_orignal,
                type: props.type,
              },
            },
            responceBarData
          );
        if (
          props.type === "IMB" &&
          signal_name === "B_PACK" &&
          props.id === "chartdivCurrImb"
        )
          fetchData(
            {
              url:
                API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusPackB_click",
              body: {
                filterdata: gloablfilter,
                signalNav: signal_name_orignal,
                type: props.type,
              },
            },
            responceBarData
          );
        if (
          props.type === "IMB" &&
          signal_name === "C_PACK" &&
          props.id === "chartdivCurrImb"
        )
          fetchData(
            {
              url:
                API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusPackC_click",
              body: {
                filterdata: gloablfilter,
                signalNav: signal_name_orignal,
                type: props.type,
              },
            },
            responceBarData
          );
        if (
          props.type === "IMB" &&
          signal_name === "D_PACK" &&
          props.id === "chartdivCurrImb"
        )
          fetchData(
            {
              url:
                API_URL_MAIN + "faultfirstpage_bus/vehicleLevalBusPackD_click",
              body: {
                filterdata: gloablfilter,
                signalNav: signal_name_orignal,
                type: props.type,
              },
            },
            responceBarData
          );
        if (
          props.type === "IMB" &&
          signal_name === "A_PACK" &&
          props.id === "chartdivSocImb"
        )
          fetchData(
            {
              url:
                API_URL_MAIN +
                "faultfirstpage_bus/vehicleLevalBusSocPackA_click",
              body: {
                filterdata: gloablfilter,
                signalNav: signal_name_orignal,
                type: props.type,
              },
            },
            responceBarData
          );
        if (
          props.type === "IMB" &&
          signal_name === "B_PACK" &&
          props.id === "chartdivSocImb"
        )
          fetchData(
            {
              url:
                API_URL_MAIN +
                "faultfirstpage_bus/vehicleLevalBusSocPackB_click",
              body: {
                filterdata: gloablfilter,
                signalNav: signal_name_orignal,
                type: props.type,
              },
            },
            responceBarData
          );
        if (
          props.type === "IMB" &&
          signal_name === "C_PACK" &&
          props.id === "chartdivSocImb"
        )
          fetchData(
            {
              url:
                API_URL_MAIN +
                "faultfirstpage_bus/vehicleLevalBusSocPackC_click",
              body: {
                filterdata: gloablfilter,
                signalNav: signal_name_orignal,
                type: props.type,
              },
            },
            responceBarData
          );
        if (
          props.type === "IMB" &&
          signal_name === "D_PACK" &&
          props.id === "chartdivSocImb"
        )
          fetchData(
            {
              url:
                API_URL_MAIN +
                "faultfirstpage_bus/vehicleLevalBusSocPackD_click",
              body: {
                filterdata: gloablfilter,
                signalNav: signal_name_orignal,
                type: props.type,
              },
            },
            responceBarData
          );
      });

      let cellSize = 20;
      series.events.on("datavalidated", function (ev) {
        let series = ev.target;
        let chart = series.chart;
        let xAxis = chart.xAxes.getIndex(0);

        // Calculate how we need to adjust chart height
        let chartHeight =
          series.data.length * cellSize +
          xAxis.height() +
          chart.get("paddingTop", 0) +
          chart.get("paddingBottom", 10);

        // Set it on chart's container
        chart.root.dom.style.height = chartHeight + "px";
      });

      return series;
    }

    createSeries(
      "male",
      am5.p100,
      "right",
      0,
      "#02569c",
      "orgLevalMale",
      "Duration (mins)",
      "signal_nm",
      "signal_desc",
      "signal_val"
    );
    createSeries(
      "female",
      0,
      "left",
      0,
      "#83A4CF",
      "orgLevalFemale",
      "Vehicle Count",
      "signal_nm",
      "signal_desc",
      "signal_val"
    );

    var cursor = chart.set(
      "cursor",
      am5xy.XYCursor.new(root, {
        behavior: "none",
      })
    );
    cursor.lineY.set("forceHidden", true);
    cursor.lineX.set("forceHidden", true);

    chart.appear(1000, 100);
    root._logo.dispose();
    return () => root.dispose();
  }, [props]);

  return (
    <>
      <WaterMark />
      <div id={props.id} style={{ height: "400px", width: "450px" }}></div>
      <div
        className="modal fade"
        id={"exampleModal__data" + props.id}
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {setsignal_name}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px', paddingTop:"0px", marginTop:"8px" }}> */}
            <div className="modal-body" style={{ maxHeight: "400px" }}>
              {/* <table className="table table-striped">
                <thead style={{ backgroundColor: '#83A4CF', color: '#fff', width:"100%", position:"sticky", top:"0px", zIndex: "1" }} >
                  <tr>
                    <th scope="col">VIN Number</th>
                    <th scope="col">City</th>
                    <th scope="col">Depo</th>
                    <th scope="col">Duration</th>
                    {show !== "sp" || props.type === "DTC" ?
                      <th scope="col">Occurrences</th> : <></>
                    }

                  </tr></thead>
                <tbody>
                  {show !== "sp" || props.type === "DTC" ?
                    <BucketTable_Fault_Click data={filteredData} /> : <BucketTable_Fault_Click_Imb data={filteredData} />
                  }
                </tbody>
              </table> */}
              {/* {show !== "sp" || props.type === "DTC" ?
                    <CommanBarTable_Bus data={filteredData} unit = {props.unit}/> : <CommanBarTable_Bus data={filteredData} unit = {props.unit}/>
                  } */}
              {/* <CommanBarTable_Bus data={filteredData} /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
